import { api } from "@bindery/convex-reader/api";
import type { ConvexReactClient } from "convex/react";

export interface Shelf {
  /** False when no reader is signed in, so nothing was sent. */
  addToShelf: (readingIds: string[]) => Promise<boolean>;
  setResumeReadings: (readingIds: string[]) => Promise<boolean>;
}

// Each write names the session's reader: the server refuses a token for any
// other reader instead of filing the shelf under it.
export function createShelf(
  client: Pick<ConvexReactClient, "mutation">,
  currentReaderId: () => string | null,
): Shelf {
  return {
    async addToShelf(readingIds) {
      const expectedReaderId = currentReaderId();
      if (expectedReaderId === null) return false;
      await client.mutation(api.library.addToShelf, {
        expectedReaderId,
        readingIds,
      });
      return true;
    },
    async setResumeReadings(readingIds) {
      const expectedReaderId = currentReaderId();
      if (expectedReaderId === null) return false;
      await client.mutation(api.library.setResumeReadings, {
        expectedReaderId,
        readingIds,
      });
      return true;
    },
  };
}
